(ns shared.core.amelia-light.components.toggle
  (:require [shared.core.reactive :as re]
            [shared.core.style :as style]
            ["@up/base-ui/components/ui/switch" :refer [Switch]]))

(defn up-toggle [{:keys [label form-path form-name checked on-checked-change] :as args}]
  (let [form-val- (when (and form-path form-name)
                    (re/subscribe [:form/val- form-path form-name]))
        checked? (if (nil? checked)
                   (when form-val- (boolean @form-val-))
                   checked)
        on-checked-change (or on-checked-change
                              (when (and form-path form-name)
                                (fn [v]
                                  (re/dispatch [:form/change form-path form-name (boolean v)]))))]
    [:div {:style {:display :flex
                   :align-items :center
                   :gap 8}}
     (when label
       [:span {:style {:color (style/alc-color "Text/primary")
                       :font-size 14
                       :line-height 1.3}}
        label])
     [:> Switch (cond-> (dissoc args :form-path :form-name)
                        (not (nil? checked?)) (assoc :checked checked?)
                        on-checked-change (assoc :on-checked-change on-checked-change))]]))